<!--实时值 virtualDeviceRTValue-->
<template>
  <div class="myvirtualDeviceRTValue">
    <div class="con" style="background-color: #eee;">
      <div class="tree-left" style="height:calc(100vh - 152px);">
        <elUnitTree @checkFun="checkFun" :dataList="virtualDeviceList"></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%;height: auto;">
          <span style="width: 60px;">应用类型</span>
          <elUnitTree2 @checkFun="checkFun2"></elUnitTree2>

          <el-button @click="mysearch" type="primary" plain class="search-btn">查询</el-button>
        </div>
        <div class="Files-table" :style="{ height: heights + 'px' }">
          <el-table :data="nowPage" stripe :max-height="heights - 20" border style="width: 100%">
            <el-table-column label="序号" width="50" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据" />
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="variableName" label="变量名" width="400">
              <template #default="{ row }">
                <span>{{ row.deviceName + "." + row.variableName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="currentValue" label="实时值" width="220" align="right">
            </el-table-column>
            <el-table-column prop="valueUnit" label="单位" width="90" align="center">
            </el-table-column>
            <el-table-column prop="changeTime" label="变化时间" width="200" align="center">
            </el-table-column>
            <el-table-column label="通讯状态" align="center" min-width="90">
              <template #default="{ row }">
                <div class="patrol public-flex" v-if="row.status == 0">
                  <p></p>
                  <span>正常</span>
                </div>
                <div class="rush public-flex" v-else>
                  <p></p>
                  <span>异常</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="divider-line"></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
isempty();
import elUnitTree from "@/components/module/newTree/elUnitTree.vue";
import elUnitTree2 from "@/components/module/newTree/elUnitTree2.vue";
import request from "@/api/http.js";
import { parseTime } from "@/utils";
export default {
  components: {
    elUnitTree,
    elUnitTree2,
  },
  props: [],
  data() {
    return {
      aaa: Math.floor(Math.random() * 10),
      timeOut: "",
      shouMenu: false,
      shouMenu2: false,
      all: [], //总no数据
      flag: false,
      nowPage: [
        {
          deviceName: "设备机电总进线数显表",
          variableName: "A相电流",
          currentValue: "790.8",
          valueUnit: "A",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "设备机电总进线数显表",
          variableName: "B相电流",
          currentValue: "770.7",
          valueUnit: "A",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "设备机电总进线数显表",
          variableName: "C相电流",
          currentValue: "780.6",
          valueUnit: "A",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "设备机电总进线数显表",
          variableName: "A相有功功率",
          currentValue: "173",
          valueUnit: "kW",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "设备机电总进线数显表",
          variableName: "B相有功功率",
          currentValue: "168.63",
          valueUnit: "kW",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "设备机电总进线数显表",
          variableName: "C相有功功率",
          currentValue: "171.54",
          valueUnit: "kW",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "设备机电总进线数显表",
          variableName: "总有功功率",
          currentValue: "513.17",
          valueUnit: "无",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
      ],

      nowPage2: [
        {
          deviceName: "相对幅值",
          variableName: "A相电流",
          currentValue: "790.8",
          valueUnit: "A",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "相位",
          variableName: "B相电流",
          currentValue: "770.7",
          valueUnit: "A",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
        {
          deviceName: "周期",
          variableName: "B相电流",
          currentValue: "770.7",
          valueUnit: "A",
          changeTime: "2022-10-17 11:36:00",
          status: 0,
        },
      ],
      deviceNos: [],
      dataed: [],
      dataed_un: [],
      defaultProps: "",
      heights: Math.round(document.getElementById("app").clientHeight * 0.74),
      apptypeValue: [],
      nowIndex: 0,
      nowApptypeGroups: [],
      from2name: {},
      columns: [
        {
          name: "设备名称",
          key: "devicename",
        },
        {
          name: "变量名称",
          key: "variablename",
        },
        {
          name: "实时值",
          key: "value",
          getTdStyleMethod(column, index, value) {
            if (parseFloat(value) == NaN) {
              return {
                color: "#FF9900",
              };
            }
          },
        },
        {
          name: "变化时间",
          key: "getTime",
        },
        {
          name: "通讯状态",
          key: "deviceState",
          getTdStyleMethod(column, index, value) {
            if (value == "正常") {
              return {
                color: "rgb(103, 194, 58)",
              };
            } else if (value == "取消") {
              return {
                color: "#999999",
              };
            }
          },
        },
      ],
      total: 0,
      currentPage: 1,
      currentSize: 15,
      nowVirtualDeviceList: [],
      copyNowVirtualDeviceList: [],
      mynum: 1,
      a: [],
      b: [{ label: "C1FB-G01-C3FA出线柜" }],
    };
  },
  created() {
    debugPage = this;
    //直接全选
  },
  beforeDestroy() {
    // 停止定时器
  },
  mounted() {
    this.apptypeValue = this.nowSelectAppTypeGroupIds;
    var d = getMenuListAll();
    if (d[0].webpage == "/platform") {
      this.nowPage = this.nowPage2;
    }
  },
  destroyed() {
    this.realTimeValueStore.commit("removeKeys", this.nowVariableNames);
  },
  computed: {
    nowSelectAppTypeGroupIds() {
      var a = this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(
        this.apptypeGroups
      );
      JSON.stringify(a);
      return a;
    },
    // nowVirtualDeviceList () {
    //   return this.$store.deviceStore.state.nowVirtualDeviceList
    // },
    variableStore() {
      return this.$store.variableStore;
    },
    deviceStore() {
      return this.$store.deviceStore;
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    realTimeValueStore() {
      return this.$store.realTimeValueStore;
    },
    variableTree() {
      if (isempty(this.nowVirtualDeviceList)) {
        return [];
      }
      var variableTreeArr = [];
      this.nowVirtualDeviceList.forEach((item) => {
        var variableTree = [];
        if (item.type == "virtualDevice") {
          if (variableTree.length == 0) {
            variableTree = this.variableStore.getters.getVariableTree(item.no);
          }
        }
        variableTree.forEach((tree) => {
          tree.devicename = item.name;
        });
        variableTreeArr.push(variableTree);
      });
      var result = [];
      variableTreeArr.forEach((item) => {
        result = result.concat(item);
      });
      return result;
    },
    apptypeGroups() {
      //debugger
      //所有已选中的设备所具有的变量类型组
      var list = [];
      var apptypeGroupIds = [];
      this.variableTree.forEach((apptypeGroup) => {
        if (!apptypeGroupIds.includes(apptypeGroup.id)) {
          if (apptypeGroup.name.indexOf("未定义") == -1) {
            apptypeGroupIds.push(apptypeGroup.id);
            list.push(apptypeGroup);
          }
        }
      });
      //排序
      let list2 = [];
      list.forEach((item) => {
        if (item.name != "门限值") {
          list2.push(item);
        }
      });
      //排序
      list2.sort((a, b) => {
        return a.serialnum - b.serialnum;
      });

      let idList = [];
      list2.forEach((item) => {
        idList.push(item.id);
      });
      this.apptypeValue = idList;
      return list2;
      // return list2.sort((a,b) => {
      //   return a.serialnum-b.serialnum
      // })
    },
    nowVariableNames() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map((item) => {
        return item.id;
      });
      var v1 = this.variableTree.filter((item) => {
        return ag.includes(item.id);
      });
      if (isempty(v1)) {
        return [];
      }
      var v2 = [];
      v1.forEach((item) => {
        item.next.forEach((i) => {
          this.from2name[i.fromName] = i.name + "(" + item.unit + ")";
          v2.push(i.fromName);
        });
      });

      return v2;
    },
    nowVariableList() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map((item) => {
        return item.id;
      });
      var v1 = this.variableTree.filter((item) => {
        return ag.includes(item.id);
      });
      if (isempty(v1)) {
        return [];
      }
      var v2 = [];
      v1.forEach((item) => {
        item.next.forEach((i) => {
          i.devicename = item.devicename;
          v2.push(i);
        });
      });
      v2.sort((a, b) => {
        return a.typeNo - b.typeNo;
      });
      return v2;
    },
    pageLen() {
      return this.dataList.length < this.currentSize
        ? this.dataList.length
        : this.currentSize;
    },

    dataList() {
      //获取值
      var vl = this.realTimeValueStore.getters.getValue(this.nowVariableNames);
      var deviceList = this.nowVariableNames
        .map((item) => item.substring(0, item.indexOf(".")))
        .distinct();
      var deviceStateMap = this.realTimeValueStore.getters.getDeviceState(
        deviceList
      );
      var v2 = this.realTimeValueStore.getters.getTime(this.nowVariableNames);
      //获取当前设备状态
      return this.nowVariableNames.map((item, index) => {
        var value = this.realTimeValueStore.getters.getText(item, vl[index]);
        var deviceState = "--";
        switch (deviceStateMap[item.substring(0, item.indexOf("."))]) {
          case 0:
            deviceState = "取消";
            break;
          case 1:
            deviceState = "正常";
            break;
        }
        var getTime =
          v2[index] != undefined
            ? new Date(parseInt(v2[index])).format("yyyy-MM-dd hh:mm:ss")
            : "--";
        if (isNaN(parseFloat(vl[index])) || isnull(parseFloat(vl[index]))) {
          value = "- -";
        }
        var name = this.from2name[item] ? this.from2name[item] : item;
        let deviceName = "";
        //这样拿貌似也不行，里面数据有问题this.nowVariableList[index].fromName.split('.')[0]
        this.nowVariableList.forEach((item2) => {
          if (item2.fromName == item) {
            //deviceName = item2.fromName.split('.')[0]
            deviceName = item2.deviceName;
          }
        });
        return {
          devicename: deviceName,
          variablename: name.subByFirstChar("."),
          value,
          getTime,
          deviceState,
        };
      });
    },
  },
  watch: {
    nowVariableNames(nv, ov) {
      this.realTimeValueStore.commit("removeKeys", ov);
      this.realTimeValueStore.commit("addKeys", nv);
    },
    apptypeValue(nv, ov) {
      this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", nv);
      let list = [];
      if (!isempty(nv)) {
        nv.forEach((item) => {
          this.apptypeGroups.forEach((item2) => {
            if (item == item2.id) {
              list.push(item2);
            }
          });
        });
      }
      this.nowApptypeGroups = list;
    },
  },
  methods: {
    getMath(index = 10) {
      //生成随机数
      let count = Math.round(Math.random() * 333);

      return count;
    },
    checkFun2(v) {
      this.a = v;
      this.mysearch();
    },
    checkFun(val) {
      this.b = val;
      this.mysearch();
    },
    // 应用类型->修改应用类型参与查询状态
    updateEnableStatus(data) {
      var params = {
        deviceNos: data.join(","),
      };
      // /variable/findAppTypeByDeviceNo
      request({
        url: "/variable/findAppTypeByDeviceNo",
        method: "get",
        params,
      }).then((res) => {
        console.log(res, "修改应用类型参与查询状态");
        if (res.code == 200) {
          this.dataed = res.data.used;
          this.all = [];
          this.defaultProps = [];
          this.dataed.map((v) => {
            if (v.children) {
              v.children.map((a) => {
                this.all.push(a.no);
                if (a.enable === 0) {
                  this.defaultProps.push(a.no);
                }
              });
            }
          });
          this.dataed_un = res.data.unused;
        }
      });
    },
    mysearch2() {
      this.$router.push("/virtualDeviceRTCurve");
    },
    mysearch() {
      this.nowPage = [];
      this.b.map((v) => {
        this.a.map((a) => {
          this.nowPage.push({
            deviceName: v.label,
            variableName: a,
            currentValue: Math.round(Math.random() * 333),
            valueUnit: "A",
            changeTime: "2022-10-17 11:36:00",
            status: 0,
          });
        });
      });
    },
    //下载excel文件
    downloadExcel() {
      let title = "<thead><tr>";
      title +=
        "<th colspan=6>" + new Date().formatByTime("-") + " 实时值" + "</th>";
      title += "</tr></thead>";
      let aa = document.getElementsByTagName("thead")[0]; //头部表达
      let bb = document.getElementsByTagName("tbody")[0]; //列表内容
      let table = title + aa.innerHTML + bb.innerHTML;
      exportToExcel(table, "实时值报告");
    },
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups;
        let idList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = idList;
      } else {
        this.nowApptypeGroup = [];
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },
    checkAppGroup(item) {
      //选中了app应用组
      this.nowApptypeGroups = item;
    },

    //分页功能
    handleSizeChange(val) {
      this.currentSize = val;
    },
    handleCurrentChange(val) {
      this.nowIndex = val - 1;
    },
  },
};
</script>

<style scoped lang="scss">
.myvirtualDeviceRTValue {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 正常
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0dae88;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #0dae88;
      }
    }

    // 非正常
    .rush {
      p {
        width: 8px;
        height: 8px;
        background-color: #ff1d1d;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #ff1d1d;
      }
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      .mycharts {
        display: flex;

        .charts-left {
          width: 35%;
        }

        .charts-right {
          width: 70%;
        }
      }
    }
  }
}
</style>
<style scoped>
.block {
  width: 20px;
  height: 20px;
  background-color: #d9d9d9;
  cursor: pointer;
  margin-left: 10px;
}

.unitMenu {
  max-width: 4rem;
  height: 4rem;
  top: 7px;
  margin-left: 78px;
  padding-top: 0.5rem;
  position: absolute;
  z-index: 99999;
}

.unitMenu .elUnitTreeBody {
  width: 2.4rem;
}

.unitMenu .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.cropper-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ul {
  padding: 0 15px;
}

.ul .li {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.ul .li .r {
  color: #378cd4;
  cursor: pointer;
}

.btns {
  width: 300px;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #d7d7d7;
  margin: 0 15px;
}

.color-span {
  display: inline-block;
  width: 15px;
  height: 15px;
  transform: translate(5px, 2px);
  color: #1a1a1a;
}

.user-arrow {
  width: 20px;
  height: 20px;
}

.tongyi-img {
  width: 20px;
  height: 20px;
}

.arrow-active {
  transform: rotateZ(180deg);
}

.topMenu {
  height: 0.5rem;
  overflow-y: hidden;
  /* overflow: hidden; */
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.nowUnit-name {
  margin-left: 0.2rem;
  width: 2.14rem;
  height: 30px;
  border: 1px solid #ccc;
  text-align: left;
  line-height: 30px;
  padding: 0px 12px;
  /* margin-left: 5px; */
  border-radius: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nowUnit-name span {
  color: #666666;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.nowUnit-name img {
  width: 18px;
  height: 18px;
  transition: 0.5s;
}

.nowUnit-active {
  border: 1px solid #409eff;
}

.nowUnit-active1 {
  border: 1px solid #fff;
}

.nowUnit-active img {
  transform: rotateZ(180deg);
}

.nowUnit-active1 img {
  transform: rotateZ(180deg);
}

/* 需要转化 */
.tags-view-container {
  height: 34px;
  width: calc(100% - 2rem);
  position: absolute;
  top: 48px;
  left: 200px;
  /* margin-left: 200px; */
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  z-index: 999;
}

.tags-view-container .content {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
}

.sidebar-logo {
  width: 32px;
  height: 32px;
  vertical-align: middle;
}

.sidebar-title {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
  margin-left: 10px;
}

/* 需要转化结束 */

.userName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1a1a1a;
}

.webTitle {
  height: 0.5rem;
  width: auto;
  text-align: center;
  line-height: 0.5rem;
  font-size: 21px;
  font-weight: bold;
  width: 500px;
  color: #212529;
}

.leftPart {
  /* width: calc(50% - 150px); */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* background-color: #2b2f3a; */
  /* background-color: #fff; */
}

.leftPart-logo {
  width: 2rem;
  height: 0.5rem;
  box-sizing: border-box;
  padding: 9px;
  /* background-color: #304156; */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.35s;
  flex-shrink: 0;
}

.leftPart-logo-active {
  width: 0.8rem;
}

.logo {
  max-width: 185px;
  max-height: 40px;
}

.rightPart {
  /* width: calc(50% - 50px); */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.leftPartImg {
  height: 48px;
  display: flex;
  align-items: center;
  width: 50px;
  /*border-bottom: 2px solid #116af0;*/
}

.rightPart .user {
  /* width: auto; */
  margin-left: 10px;
  max-width: 2rem;
  min-width: 0.2rem;
  /* height: .2rem; */
}

.rightPart .userSelect {
  cursor: pointer;
  width: auto;
  max-width: 2rem;
  min-width: 0.08rem;
  height: 0.06rem;
  margin-right: 20px;
  margin-top: 11px;
}

.unitSelect {
  min-width: 1rem;
  height: 100%;
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
}

.unitSelect>div>input {
  width: 150px;
  background: rgba(0, 0, 0, 0);
  border: 0;
  /* border-left: 1px #49649c solid; */
  border: 1px solid #dcdfe6;
  border-radius: 0;
  padding: 5px 10px;
  height: 20px;
  line-height: 20px;
  outline: none;
  margin: 0 10px;
  color: white;
}

.userMenu {
  padding-top: 0.5rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999;
}

.area-tree {
  position: absolute;
  max-width: 2.5rem;
  height: 4rem;
  /* margin-left: 4rem; */
  /* top: 0; */
  top: 0;
  /* right: 0px; */
  margin-left: 19px;
  padding-top: 0.5rem;
  z-index: 99999;
  width: 77%;
}

.area-tree .elUnitTreeBody {
  width: 2.4rem;
}

.area-tree .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.menuItem {
  height: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.05rem 0.1rem;
  width: auto;
  cursor: pointer;
  background: white;
  border-left: solid 0.01rem #babec2;
  border-right: solid 0.01rem #babec2;
  border-bottom: solid 0.01rem #babec2;
}

.menuItem:last-child {
  border-radius: 0 0 0.05rem 0.05rem;
}

.menuItem>span {
  text-align: left;
  width: 0.7rem;
  padding-left: 0.1rem;
}

.tool-class {
  width: 50%;
}

.nowTimeBox {
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
  /* color: white; */
  color: #666666;
  line-height: 50px;
  margin-right: 10px;
}

.msgDialog {
  position: absolute;
  width: 360px;
  height: 440px;
  background: white;
  z-index: 5;
  top: 50px;
  right: 20px;
  border-radius: 5px;
  border: 1px silver solid;
  z-index: 110;
}

.msgDialog>p {
  padding-right: 20px;
  line-height: 40px;
  text-align: right;
  border-bottom: 1px silver solid;
  color: #0092dc;
}

/* 修改默认列表样式 */

.msgDialog>>>ul.list-body {
  border-radius: 0;
}

.msgDialog>>>ul.list-body>li {
  padding: 0;
  border-bottom: none;
  background: none;
  cursor: default;
}

.msgOperate {
  overflow: hidden;
  padding: 0 24px;
  border-bottom: solid 1px #cccccc;
}

.msgOperate>button {
  height: 20px;
  box-sizing: border-box;
  margin: 8px 12px;
  color: #0f87db;
  padding: 0 8px;
  background: #ffffff;
  outline: none;
  border: solid 1px #ffffff;
  border-radius: 10px;
  cursor: pointer;
}

.msgOperate>.isFilter {
  border-color: #0f87db;
}

.isFilter {
  color: #0f87db;
  background: none;
}

.msgOperate>span {
  float: right;
  line-height: 36px;
}

.filterDialog {
  position: absolute;
  height: 300px;
  width: 250px;
  background: white;
  top: 50px;
  z-index: 100;
}

.unitName {
  max-width: 140px;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.existMsg {
  position: absolute;
  left: 5px;
  top: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: red;
  color: #ffffff;
  font-size: 0.12rem;
  text-align: center;
  line-height: 20px;
  transform: scale(0.6);
}

.unreadMsgInfo {
  padding: 10px 24px 0 24px;
}

.unreadHead {
  margin-bottom: 6px;
  overflow: hidden;
}

.msgTypeName {
  float: left;
  background: #0582da;
  line-height: 18px;
  padding: 0 8px;
  border-radius: 8px;
  font-size: 0.12rem;
  color: #ffffff;
}

.msgMarkBtn {
  float: right;
  height: 18px;
  box-sizing: border-box;
  border: solid 1px #0f87db;
  border-radius: 8px;
  font-size: 0.12rem;
  padding: 0 8px;
  line-height: 16px;
  color: #0f87db;
  background: #ffffff;
  cursor: pointer;
}

.msgTimeText {
  float: right;
  line-height: 18px;
  font-size: 0.12rem;
  color: #0f87db;
}

.msgIntro {
  font-size: 0.12rem;
  text-indent: 2em;
  padding-bottom: 10px;
  border-bottom: solid 1px #cccccc;
  white-space: normal;
}

.unReadMsg {
  background-color: #e3ebf1;
}
</style>
